export const HEALTH_INSURANCE_MODALS = {
  create: 'create',
  delete: 'delete',
  edit: 'edit',
};

export const DEFAULT_HEALTH_INSURANCE = {
  _id: '',
  name: '',
  healthInsuranceNumber: 0,
  createdBy: '',
  companyId: '',
  createdAt: 'string',
};
